import { GeofencePointsType } from '../../types/ModelTypes'

export interface IsLocatableByPosition {
  getLatLon: () => GeofencePointsType | undefined
}

export function IsLocatableByPosition(object: any): object is IsLocatableByPosition {
  return 'getLatLon' in object
}
